import { useLocalStorage } from "usehooks-ts";

export const useAccessToken = () => {
  return useLocalStorage<string | undefined>(
    process.env.NEXT_PUBLIC_LS_TOKEN as string,
    undefined
  );
};
